module.exports = "https://www.gc-pro.gnp.com.mx/9f80b374420f54955dddf4b63cb2cb57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/03-recibo-over.svg
// module id = 8037
// module chunks = 0